import { render } from "./Home.vue?vue&type=template&id=65c72c67&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=65c72c67&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/aikangmall-im-seller/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c72c67"]])

export default __exports__